// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-libs_core_src_lib_services_date_date_service_ts-libs_core_src_lib_tokens_unleash-flag-7c23a5":"25ba69d370ef85c5","libs_wl_westpac_src_lib_gift-card_gift-card-wrapper_module_ts":"e00ed6c25523930b","apps_bom_src_app_offer_offer-wrapper_module_ts":"c46a5bf2e1acf4f9"}[chunkId] + ".js";
};